import React, { useEffect } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { selectFormLanguage, selectSource } from "redux/form/form.selector";
import {
  Stripe,
  StripeElements,
  StripePaymentElementChangeEvent,
} from "@stripe/stripe-js";
import { selectIsCheckoutCallError } from "redux/helpers/helpers.selector";
import { FormSourceType, PaymentMethods } from "utils/interfaces";
import { updatePaymentMethod } from "redux/form/form.reducer";

interface Props {
  updateStripe: (stripe: Stripe) => void;
  updateStripeElements: (elements: StripeElements) => void;
}

// istanbul ignore next
const StripePaymentElement: React.FC<Props> = ({
  updateStripe,
  updateStripeElements,
}) => {
  // GLOBAL STATE
  const formLanguage = useAppSelector(selectFormLanguage);
  const isCheckoutCallError = useAppSelector(selectIsCheckoutCallError);
  const source = useAppSelector(selectSource);
  const dispatch = useAppDispatch();
  const isOverlayForm = source === FormSourceType.OVERLAY_FORM;

  // Stripe config
  const stripe = useStripe();
  const elements = useElements();

  const handlePaymentElementChange = (
    event: StripePaymentElementChangeEvent,
  ) => {
    const paymentMethod = event.value.type;

    dispatch(
      updatePaymentMethod(
        paymentMethod === "card"
          ? "credit_card"
          : (paymentMethod as PaymentMethods),
      ),
    );
  };

  useEffect(() => {
    if (stripe) updateStripe(stripe);
  }, [stripe]);

  useEffect(() => {
    if (elements) updateStripeElements(elements);
  }, [elements]);

  useEffect(() => {
    if (elements) {
      elements.update({ locale: formLanguage });
    }
  }, [formLanguage]); // eslint-disable-line

  return (
    <div style={{ marginBottom: isOverlayForm ? "32px" : "20px" }}>
      <PaymentElement
        options={{
          readOnly: isCheckoutCallError,
          terms: { card: "never", applePay: "never", googlePay: "never" },
          fields: {
            billingDetails: {
              address: {
                country: "never",
                postalCode: "never",
              },
            },
          },
          layout: "tabs",
        }}
        onChange={handlePaymentElementChange}
        id="payment-element"
      />
    </div>
  );
};

export default StripePaymentElement;
